const convertToByte = (byte, hideZeroDecimals) => {
    const s = ["bytes", "KB", "MB", "GB", "TB", "PB"];

    if (byte === undefined) return null;

    if (typeof byte !== "bigint") {
        byte = BigInt(byte);
    }

    let e = 0n;
    let base = 1000n;

    while (byte >= base && e < BigInt(s.length - 1)) {
        byte /= base;
        if (byte < Number.MAX_SAFE_INTEGER) {
            byte = Number(byte);
            base = 1000;
        }
        e++;
    }

    let result = Number(byte); // Convert to Number for readable format
    let formattedResult = "";
    if (hideZeroDecimals) {
        formattedResult = result % 1 === 0 ? result.toString() : result.toFixed(2);
    } else {
        formattedResult = result.toFixed(2);
    }

    return formattedResult + " " + s[Number(e)];
};

export default convertToByte;
